import { Expose } from 'class-transformer';

export class ClubEntity {
  name: string;
  street: string;
  street2: string;

  @Expose({ name: 'postalcode' })
  postalCode: string;

  city: string;
  state: string;
  country: string;
  email: string;
  phone: string;
  homepage: string;
  facebookLink: string;
  twitterLink: string;
  instagramLink: string;
  linkToVV: string;
  linkToFIBU: string;

  @Expose({ name: 'logourl' })
  logoUrl: string;
}
